module.exports = __webpack_public_path__ + "static/img/img01.cc7e929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv010/img01.jpg
// module id = DdQg
// module chunks = 0